export default "__VITE_ASSET__wXJo4hP5__"